import { alpha } from '@mui/material';
const usePreviewEventFormStyles = () => {
    return {
        mainContainer: {
            minHeight: '100dvh',
            py: '20px',
            px: '40px',
            backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08)
        },
        contentContainer: {
            display: 'flex',
            justifyContent: 'center',
            pt: '40px'
        }
    };
};
export default usePreviewEventFormStyles;
